export default __webpack_public_path__ + "static/media/lgn-lg-3.596658b0.webp";